var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalBalanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4C1 2.067 2.567 0.5 4.5 0.5H40.5C42.433 0.5 44 2.067 44 4V40C44 41.933 42.433 43.5 40.5 43.5H4.5C2.567 43.5 1 41.933 1 40V4Z",
    fill: "#FDEED7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4C1 2.067 2.567 0.5 4.5 0.5H40.5C42.433 0.5 44 2.067 44 4V40C44 41.933 42.433 43.5 40.5 43.5H4.5C2.567 43.5 1 41.933 1 40V4Z",
    stroke: "#F7BF7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 30.24C12.21 30.23 12.21 30.22 12.21 30.22L17.71 24.72C17.72 24.71 17.73 24.71 17.74 24.7C17.11 24.26 16.34 24 15.5 24C13.29 24 11.5 25.79 11.5 28C11.5 28.75 11.71 29.46 12.08 30.06C12.12 30.12 12.16 30.18 12.2 30.24Z",
    fill: "#EF7C20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 25.75C18.79 25.76 18.79 25.77 18.78 25.78L13.28 31.28C13.27 31.29 13.26 31.29 13.25 31.3C13.89 31.74 14.66 32 15.5 32C16.96 32 18.23 31.22 18.92 30.06C19.29 29.46 19.5 28.75 19.5 28C19.5 27.16 19.24 26.39 18.8 25.75Z",
    fill: "#EF7C20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14H17.5C14.5 14 12.5 15.5 12.5 19V22.56C12.5 22.93 12.88 23.16 13.21 23.01C14.19 22.56 15.32 22.39 16.51 22.6C19.14 23.07 21.07 25.51 21 28.18C20.99 28.6 20.93 29.01 20.82 29.41C20.74 29.72 20.99 30.01 21.31 30.01H27.5C30.5 30.01 32.5 28.51 32.5 25.01V19C32.5 15.5 30.5 14 27.5 14ZM22.5 24.5C21.12 24.5 20 23.38 20 22C20 20.62 21.12 19.5 22.5 19.5C23.88 19.5 25 20.62 25 22C25 23.38 23.88 24.5 22.5 24.5ZM29.75 24C29.75 24.41 29.41 24.75 29 24.75C28.59 24.75 28.25 24.41 28.25 24V20C28.25 19.59 28.59 19.25 29 19.25C29.41 19.25 29.75 19.59 29.75 20V24Z",
    fill: "#EF7C20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBalanceIcon);
export default __webpack_public_path__ + "static/media/total_balance_icon.af9d9cb09aacec62ed1e0b1b77823d71.svg";
export { ForwardRef as ReactComponent };